import { Injectable } from '@angular/core';
import { AbstractHttpService } from './abstract-http-service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { OfferSetBulkActionResponse } from '../model/offer-set-bulk-action.model';

@Injectable({
  providedIn: 'root'
})
export class OfferSetRegistryService extends AbstractHttpService {
  defaultOptions = {
    headers: this.contentTypeJsonHeaders,
    withCredentials: true
  };

  constructor(private httpClient: HttpClient) {
    super();
  }

  /**
   * Executes a sync action on selected Offer Sets
   */
  public callOfferRegistryService(accountId, offerType: string = ''): any {
    const payload = {
      accountId: accountId,
      offerType: offerType
    };

    return this.httpClient
      .post<OfferSetBulkActionResponse>(
        `//${environment.autoDomain}:${environment.autoPort}/api/offers-registry/sync`,
        payload,
        this.defaultOptions
      )
      .pipe(catchError(this.handleError));
  }
}
